import React from "react";
const RenderComponent = ({component, ...props}) => {
    //console.log('render component',props);
    const Comp = component;
    
    if(Comp)
        return <Comp {...props} />
}

export default RenderComponent;